import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'statusClass'
})
export class StatusClassPipe implements PipeTransform {

    transform(value: any, args?: any): any { // 5 | numberToArray
        switch (value) {
            case 'VAL':
                return 'valid';
            case 'ATT':
                return 'waiting';
            case 'REF':
                return 'refused';
            case 'ANN':
                return 'deleted';
            default:
                return 'waiting';
        }
    }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/statusClass.pipe.ts